import { Controller } from '@hotwired/stimulus'
import { loadSwiper } from 'utils/loadSwiper'

export default class extends Controller {
  static targets = ['slider', 'next', 'prev']

  connect() {
    const sliderElement = this.sliderTarget
    if (!sliderElement) return

    this.observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return

          obs.disconnect()

          loadSwiper().then(({ Swiper, Navigation }) => {
            Swiper.use([Navigation])

            new Swiper(sliderElement, {
              spaceBetween: 40,
              slidesPerView: 1,
              disabledClass: 'disable',
              navigation: {
                nextEl: this.nextTarget,
                prevEl: this.prevTarget
              },
              breakpoints: {
                769: {
                  slidesPerView: 1.4
                }
              }
            })
          })
        })
      },
      { rootMargin: '200px' }
    )

    this.observer.observe(sliderElement)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
